function animateValue (el, start, end, duration, suffix) {
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const current = Math.floor(progress * (end - start) + start);
        el.textContent = formatNumber(current, suffix);
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

function formatNumber (num, suffix) {
    if (suffix === "k") {
        return (num / 1000).toFixed(1) + "k+";
    }
    if (suffix === "+") {
        return num.toLocaleString() + "+";
    }
    // Add thousands separators for regular numbers
    return num.toLocaleString();
}

function parseValue (text) {
    let cleaned = text.replace(/,/g, '');
    if (cleaned.includes('k')) {
        return { number: parseFloat(cleaned) * 1000, suffix: 'k' };
    } else if (cleaned.includes('+')) {
        return { number: parseInt(cleaned), suffix: '+' };
    } else {
        return { number: parseInt(cleaned), suffix: '' };
    }
}

export function initCounters ({ selector = '.counter', duration = 1500 } = {}) {
    const counters = document.querySelectorAll(`${selector} .counter__num`);
    counters.forEach(counter => {
        const { number, suffix } = parseValue(counter.textContent);
        counter.dataset.target = number;
        counter.dataset.suffix = suffix;
        counter.textContent = '0' + (suffix === 'k' || suffix === '+' ? suffix : '');
    });

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const section = entry.target;
                const nums = section.querySelectorAll('.counter__num');
                nums.forEach(num => {
                    if (!num.dataset.animated) {
                        animateValue(num, 0, parseInt(num.dataset.target), duration, num.dataset.suffix);
                        num.dataset.animated = "true";
                    }
                });
                observer.unobserve(section);
            }
        });
    }, { threshold: 0.3 });

    document.querySelectorAll(selector).forEach(counterBlock => {
        observer.observe(counterBlock);
    });
}